module.exports = __webpack_public_path__ + "img/news-ilu.f1a41b20.png";